import {getFileFromDirectus, getPipConfigDirectus} from '../../services/APIService'
import axios from 'axios'
let directusUrl = ''
export const retrieveConfig = async ({rootState, commit, dispatch, rootGetters}, {oid, org}) => {
  directusUrl = rootGetters['parantion/getDirectusUrl']
  const config = await getPipConfigDirectus(directusUrl, oid)
  if (!config) return
  commit('SET_CONFIG', {config, org})
  if (config['organisation_image']) dispatch('retrieveOrgLogo', config['organisation_image'])
  if (config['organisation_image_mobile']) dispatch('retrieveOrgLogoMobile', config['organisation_image_mobile'])
  if (config['background_image']) dispatch('retrieveBackground', config['background_image'])
  if (config['kml_file']) dispatch('retrieveKmlFile', config['kml_file'])
  if (config['css']) dispatch('setStyle', config['css'])
}
export const setStyle = async ({commit}, css) => {
  let styleEl = document.getElementById('custom_pip_style')
  if (!styleEl) {
    styleEl = document.createElement('style')
    styleEl.setAttribute('id', 'custom_pip_style')
    // Append <style> element to <head>
    styleEl.innerText = css
    document.head.appendChild(styleEl)
  } else {
    styleEl.innerText = css
  }
}
export const retrieveOrgLogo = async ({commit}, id) => {
  commit('SET_ORG_LOGO', await getFileFromDirectus(directusUrl, id))
}
export const retrieveOrgLogoMobile = async ({commit}, id) => {
  commit('SET_ORG_LOGO_MOBILE', await getFileFromDirectus(directusUrl, id))
}
export const retrieveBackground = async ({commit}, id) => {
  commit('SET_BG_IMG', await getFileFromDirectus(directusUrl, id))
}
export const retrieveKmlFile = async ({commit}, id) => {
  commit('SET_KML_FILE', await getFileFromDirectus(directusUrl, id))
}
export const getRegistrationFields = async ({commit, state, dispatch}) => {
  const directusRegistrationFields = state.config['registration_fields'] // {class, default, icon, label, name, required, type, mask, selectOptions}
  // do these api-calls at the same time for efficiency
  const [varDefinitions, userFieldAnswers] = await Promise.all([
    dispatch('getUserVarDefinitions'),
    dispatch('getUserFieldAnswers', directusRegistrationFields)])
  // varname, options[]
  const varoptions: [string, any[]][] = await Promise.all(await dispatch('getUserVarOptionDefinitions', varDefinitions.filter(vars => vars.datatype === 'varoption')))
  const toCommit = Object.keys(userFieldAnswers).map(key => {
    const jsonDefFromDirectus = directusRegistrationFields.find(f => f.name === key)
    const backendVarDefinition = varDefinitions.find(v => v.name === key)
    if (Array.isArray(userFieldAnswers[key])) {
      userFieldAnswers[key].value = userFieldAnswers[key].name
      jsonDefFromDirectus.selectOptions = varoptions.find(([varName, varO]) => varName === key)[1]
    }
    jsonDefFromDirectus.required = backendVarDefinition.require !== 0 // always use the required status from the "backend" var definition, not from directus.
    jsonDefFromDirectus.label = backendVarDefinition.label // always use the label from the "backend" var definition, not from directus.
    jsonDefFromDirectus.default = userFieldAnswers[key] // the value that the component uses for the v-model; the question 'answer'.
    return jsonDefFromDirectus
  })
  commit('SET_REGISTRATION_FIELDS', toCommit)
}
/**
 * Returns a promise with the Var-definitions
 */
export async function getUserVarDefinitions({rootState}) {
  return axios.get(rootState.parantion.baseUrl + `/v51/var?vartype=user`).then(res => res.data.var)
}
/**
 * Returns the values (answers) of the fields
 * @param regFields the fields as defined in directus
 */
export async function getUserFieldAnswers({rootState}, regFields) {
  return axios.get(rootState.parantion.baseUrl + `/v51/user/${rootState.parantion.user.user.uh}/field`, {
    params: {
      field: regFields.map(field => field.name)
    }
  }).then(res => res.data.field)
}
/**
 * Returns select-options mapped to the parent varname
 * @param optiongroupVars The optiongroup-vars out of the var-list we fetched earlier from Backend (not directus)
 * @returns an array of arrays; [varName, varOptions][]
 */
export async function getUserVarOptionDefinitions({rootState}, optiongroupVars) {
  const voghList: [string, string][] = optiongroupVars.map(varDef => [varDef.name, varDef.vogh])
  return voghList.map(([name, vogh]) => axios.get(rootState.parantion.baseUrl + `/v51/varoption/${vogh}/option`)
    .then(res => [name, res.data.varoptiongroup]))
}
